<div class="cl-dialog">
  <app-cli-providers (connected)="onConnected()"></app-cli-providers>

  <div class="cl-actions">
    <button type="button" class="br-btn br-btn--ghost" (click)="cancel()">Cancel</button>
  </div>
</div>
